import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetClubNameFilter, resetDepartmentsFilter, setClubNameFilter, setDepartmentsFilter } from '../../../redux/reducers/common';
import AutoComplete from '../../AutoComplete';
import { Box } from '@mui/material';
import { getClubDepartments } from '../../../api/club';
import { setDepartmentList } from '../../../redux/reducers/evaluation';
import { useTranslation } from 'react-i18next';
import { resetActionsArchivedFilter, resetActionsLinkedToFilter, resetProjectsArchivedFilter, setActionsArchivedFilter, setActionsLinkedToFilter, setProjectsArchivedFilter } from '../../../redux/reducers/actionPlan';

const styles: any = {
  root: {
    display: 'flex',
    gap: '10px',
    marginLeft: '5px',
    justifyContent: 'space-between',
    paddingTop: '5px',
    marginRight: '25px',
  },
};

const FiltersWrapper: React.FC = () => {
  const [t] = useTranslation();
  const selectedDepartments = useSelector((state:any) => state.common.departmentsFilter);
  const departmentList = useSelector((state:any) => state.evaluation.departmentList);
  const isActions = useSelector((state:any) => state.actionPlan.isActions);
  const selectedArchivedStatuses = useSelector((state:any) => !isActions ? 
                                                state.actionPlan.projectsArchivedFilter : 
                                                state.actionPlan.actionsArchivedFilter);
  const selectedActionsLinkedTo = useSelector((state:any) => state.actionPlan.actionsLinkedToFilter);
  const clubData = [{ id: 0, name: "NONE" }, ...useSelector((state:any) => state.common.myClubs)];
  const isAdmin = useSelector((state:any) => state.common.isAdmin);
  const clubDetails = useSelector((state:any) => { return state.clubDetails });

  const [departmentOptions, setDepartmentOptions] = useState(departmentList);
  const [archivedOptions, setArchivedOptions] = useState([
    {id: 0, name: t('ALL')},
    {id: 1, name: t('ACTIVE')},
    {id: 2, name: t('ARCHIVED')}
  ]);
  const [actionsLinkedToOptions, setActionsLinkedToOptions] = useState([
    {id: 0, name: t('ALL')},
    {id: 1, name: t('EVALUATION')},
    {id: 2, name: t('LICENCE')}
  ]);

  const dispatch = useDispatch();

  // useEffect(() => {
  //   if(selectedDepartments && selectedDepartments.length > 0) {
  //     const departmentIds = selectedDepartments?.map((d:any) => d.id);
  //     setDepartmentOptions(departmentList?.filter((d:any) =>  (departmentIds.includes(d.id) || departmentIds.length == 0)));
  //   }
  // }, [selectedDepartments]);

  useEffect(() => {
    const fetchDepartments = async () => {
        const response = await getClubDepartments({ clubId: clubDetails?.id });
        return response;
    }
    (departmentList.length == 0 ||
    departmentList == undefined) &&
    fetchDepartments()
    .then((res) => {
      dispatch(setDepartmentList(res));
      setDepartmentOptions(res);
    });
  }, [])
  
  const manageArchivedStatusSelect = (option:any) => {
    const index = selectedArchivedStatuses.findIndex((obj:any) => obj.id == option.id);
    let tempArr:any = selectedArchivedStatuses && selectedArchivedStatuses?.length > 0 ? [...selectedArchivedStatuses] : [];
      if (index !== -1) {
        tempArr.splice(index, 1);
    } else {
      tempArr.push(option);
    }
    if (isActions) {
      dispatch(setActionsArchivedFilter(tempArr));
    } else {
      dispatch(setProjectsArchivedFilter(tempArr));
    }
  }

  const manageDepartmentSelect = (league:any) => {
    const index = selectedDepartments?.findIndex((obj:any) => obj.id == league.id);
    let tempArr:any = selectedDepartments && selectedDepartments?.length > 0 ? [...selectedDepartments] : [];
      if (index !== -1) {
        tempArr.splice(index, 1);
    } else {
      tempArr.push(league);
    }
    dispatch(setDepartmentsFilter(tempArr));
  }
  
  const manageActionsLinkedToSelect = (league:any) => {
    const index = selectedActionsLinkedTo?.findIndex((obj:any) => obj.id == league.id);
    let tempArr:any = selectedActionsLinkedTo && selectedActionsLinkedTo?.length > 0 ? [...selectedActionsLinkedTo] : [];
      if (index !== -1) {
        tempArr.splice(index, 1);
    } else {
      tempArr.push(league);
    }
    dispatch(setActionsLinkedToFilter(tempArr));
  }

  return (
    <div className="filtersWrapperRoot" style={styles.root}>
      {/* Archived Status filter */}
      <Box sx={{ width: '200px' }}>
        <AutoComplete 
        options={archivedOptions}
        selectedValues={selectedArchivedStatuses}
        handleMenuClick={(d:any) => {manageArchivedStatusSelect(d)}} 
        label={'Archived Status'}
        clickReset={() => {dispatch(isActions ? resetActionsArchivedFilter() : resetProjectsArchivedFilter())}}
        isMultiple={true}
        />
      </Box>
      {/* Departments filter */}
      <Box sx={{ width: '200px' }}>
        <AutoComplete 
        options={departmentOptions}
        selectedValues={selectedDepartments}
        handleMenuClick={(d:any) => {manageDepartmentSelect(d)}} 
        label={'Departments'}
        clickReset={() => {dispatch(resetDepartmentsFilter())}}
        isMultiple={true}
        />
      </Box>
      {/* Linked to filter */}
      {
        isActions &&
        <Box sx={{ width: '200px' }}>
          <AutoComplete 
          options={actionsLinkedToOptions}
          selectedValues={selectedActionsLinkedTo}
          handleMenuClick={(d:any) => {manageActionsLinkedToSelect(d)}} 
          label={'Linked To'}
          clickReset={() => {dispatch(resetActionsLinkedToFilter())}}
          isMultiple={true}
          />
        </Box>
      }
    </div>
  );
};

export default FiltersWrapper;
